import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { Carousel } from '../Carousel';
import { BONUSES, BONUS_GROUP } from '../../data/catio';
function FreeBadge({
  className = ''
}: {
  className?: string;
}) {
  return <span className={`label-tech inline-flex items-center rounded-full border border-ember bg-paper px-3 py-1.5 text-ember ${className}`} data-id="element-126" data-mp="2tspx3h1v4xyc">
      Included free
    </span>;
}

/** Five real bonus covers (one per view on mobile) + the group composition as a reminder. */
export function BonusSection() {
  return <section id="bonuses" aria-labelledby="bonus-title" className="bg-paper py-12 sm:py-20" data-id="element-127" data-mp="3rh9haxggcokl">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-128" data-mp="3cq0lg6lyi6z0">
        <SectionHeading id="bonus-title" eyebrow="Extra value · At no additional cost" title={<>
              And You’ll Also Get 5 Practical Bonuses —{' '}
              Included <span className="text-ember" data-id="element-130" data-mp="e121pq2hzdhn">FREE</span>
            </>} lead="Extra planning, safety, budgeting, setup and maintenance tools to help you get more from CATIO READY™ — at no additional cost." data-id="element-129" data-mp="3holp6g0f38s7" />

        <div className="mt-8 sm:mt-10" data-id="element-131" data-mp="32z3j6c9jpjtk">
          <Carousel items={BONUSES} getKey={bonus => bonus.number} label="Free bonuses" itemClassName="w-[84%] sm:w-[46%] lg:w-[31.5%]" renderItem={bonus => <article className="flex w-full flex-col overflow-hidden rounded-[16px] border border-line bg-paper" data-id="element-133" data-mp="3qph8vw4nr6kz">
                <div className="relative bg-stone" data-id="element-134" data-mp="3lrftpmacrres">
                  <img src={bonus.src} alt={bonus.alt} width={bonus.width} height={bonus.height} loading="lazy" decoding="async" className="mx-auto aspect-[1122/1402] w-full object-cover" data-id="element-135" data-mp="4k3timjv9hzw" />
                  <FreeBadge className="absolute left-3 top-3 shadow-sm" data-id="element-136" data-mp="21dp09zulj7jb" />
                </div>
                <div className="flex flex-1 flex-col border-t border-line px-5 pb-5 pt-4" data-id="element-137" data-mp="2r1swul14sruo">
                  <p className="label-tech text-ember" data-id="element-138" data-mp="2v23cyqin0yn9">Bonus {bonus.number}</p>
                  <h3 className="mt-1.5 font-display text-[1.35rem] leading-[1.15] text-ink" data-id="element-139" data-mp="2zzmwa4u701m2">
                    {bonus.title}
                  </h3>
                  <p className="mt-2 text-[0.92rem] leading-relaxed text-graphite" data-id="element-140" data-mp="39yu5qgxt3c3w">
                    {bonus.description}
                  </p>
                </div>
              </article>} data-id="element-132" data-mp="3hqcd2xkhdrci" />
        </div>

        <div className="mt-12 grid items-center gap-6 border-t border-line pt-10 sm:mt-16 lg:grid-cols-2 lg:gap-12" data-id="element-141" data-mp="3iqntanbr5n2z">
          <img src={BONUS_GROUP.src} alt={BONUS_GROUP.alt} width={BONUS_GROUP.width} height={BONUS_GROUP.height} loading="lazy" decoding="async" className="w-full rounded-[14px]" data-id="element-142" data-mp="3np7ger2314wx" />
          <div className="text-center lg:text-left" data-id="element-143" data-mp="1m1me7lqbndsf">
            <h3 className="font-display text-[1.85rem] leading-[1.12] text-ink sm:text-[2.4rem]" data-id="element-144" data-mp="1m2e6onomgveh">
              All 5 Bonuses Are Included <span className="text-ember" data-id="element-145" data-mp="1c2x7mp3vlfrh">Free</span>
            </h3>
            <p className="mt-3 text-[1rem] leading-relaxed text-graphite" data-id="element-146" data-mp="1c35ikbgfub01">
              Five additional practical resources. No additional charge.
            </p>
          </div>
        </div>
      </div>
    </section>;
}